import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Heart, EnvelopeSimple, CheckCircle, ArrowLeft } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await axios.post(`${API_URL}/api/auth/forgot-password`, { email });
      setEmailSent(true);
    } catch (err) {
      // Don't reveal if email exists or not for security
      setEmailSent(true);
    }

    setIsLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4" data-testid="forgot-password-page">
      <div className="w-full max-w-md space-y-8">
        {/* Logo */}
        <div className="flex items-center justify-center gap-2 text-primary">
          <Heart weight="fill" className="w-10 h-10" />
          <span className="text-2xl font-bold font-[Manrope]">MEDICULDIGITAL</span>
        </div>

        <div className="medical-card p-8">
          {!emailSent ? (
            <>
              <div className="text-center mb-6">
                <h1 className="text-2xl font-bold font-[Manrope] text-foreground mb-2">
                  Ai uitat parola?
                </h1>
                <p className="text-muted-foreground">
                  Introdu adresa de email și îți vom trimite instrucțiuni pentru resetarea parolei.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6" data-testid="forgot-password-form">
                {error && (
                  <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-lg text-destructive text-sm">
                    {error}
                  </div>
                )}

                <div className="space-y-2">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    placeholder="exemplu@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    data-testid="forgot-password-email-input"
                    className="h-12"
                  />
                </div>

                <Button 
                  type="submit" 
                  className="w-full h-12 gap-2"
                  disabled={isLoading}
                  data-testid="forgot-password-submit"
                >
                  {isLoading ? (
                    <>
                      <span className="w-5 h-5 border-2 border-primary-foreground/30 border-t-primary-foreground rounded-full animate-spin" />
                      Se trimite...
                    </>
                  ) : (
                    <>
                      <EnvelopeSimple weight="bold" className="w-5 h-5" />
                      Trimite email de resetare
                    </>
                  )}
                </Button>
              </form>
            </>
          ) : (
            <div className="text-center py-4" data-testid="email-sent-confirmation">
              <CheckCircle weight="fill" className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h2 className="text-xl font-bold font-[Manrope] text-foreground mb-2">
                Email trimis!
              </h2>
              <p className="text-muted-foreground mb-6">
                Dacă există un cont asociat cu adresa <strong>{email}</strong>, 
                vei primi un email cu instrucțiuni pentru resetarea parolei.
              </p>
              <p className="text-sm text-muted-foreground">
                Verifică și folderul de spam dacă nu găsești emailul.
              </p>
            </div>
          )}

          <div className="mt-6 text-center">
            <Link 
              to="/login" 
              className="inline-flex items-center gap-2 text-sm text-primary hover:underline"
              data-testid="back-to-login-link"
            >
              <ArrowLeft weight="bold" className="w-4 h-4" />
              Înapoi la conectare
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
